import React, { useEffect, useState } from "react";
import { getVisitorsList } from "../../../services/apiService";
import "../styles/Productlist.css";

const VisitorsList = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchVisitors = async () => {
    try {
      setLoading(true);
      const res = await getVisitorsList();
      setList(res?.data || res || []);
    } catch (error) {
      console.error("Visitors list error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisitors();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const filteredList = list.filter((item) => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      (item?.name && item.name.toLowerCase().includes(term)) ||
      (item?.mobile && item.mobile.toLowerCase().includes(term)) ||
      (item?.email && item.email.toLowerCase().includes(term)) ||
      (item?.org && item.org.toLowerCase().includes(term)) ||
      (item?.city && item.city.toLowerCase().includes(term))
    );
  });

  const totalItems = filteredList.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = (page - 1) * pageSize;
  const paginatedList = filteredList.slice(startIndex, startIndex + pageSize);

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div
          className="card-header text-white d-flex justify-content-between align-items-center"
          style={{ backgroundColor: "#005b8f" }}
        >
          <h2 className="mb-0">Visitors List</h2>
        </div>

        <div className="card-body">
          <div className="d-flex justify-content-start mb-3">
            <input
              type="text"
              className="form-control w-25"
              placeholder="Search by Name / Mobile / Email / Org / City"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div
              className="table-responsive"
              style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
            >
              <table
                className="table table-bordered table-hover"
                style={{ minWidth: 1300 }}
              >
                <thead className="table-dark">
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    {/* <th>Phone</th> */}
                    <th>Email</th>
                    <th>Website</th>
                    <th>Organization</th>
                    <th>GST</th>
                    <th>Dealing Items</th>
                    <th>Dealing Brands</th>
                    <th>Address</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Pincode</th>
                    {/* <th>Client ID</th>
                    <th>Exp. Name</th>
                    <th>Exp. Year</th> */}
                  </tr>
                </thead>
                <tbody>
                  {filteredList.length === 0 ? (
                    <tr>
                      <td colSpan="13" className="text-center">
                        No records found
                      </td>
                    </tr>
                  ) : (
                    paginatedList.map((item, index) => (
                      <tr key={item?.id || index}>
                        <td>{startIndex + index + 1}</td>
                        <td>{item?.name}</td>
                        <td>{item?.mobile}</td>
                        {/* <td>{item?.phone}</td> */}
                        <td>{item?.email}</td>
                        <td>{item?.webiste}</td>
                        <td>{item?.org}</td>
                        <td>{item?.gst}</td>
                        <td>{item?.dealingitems}</td>
                        <td>{item?.dealingbrands}</td>
                        <td>{item?.address}</td>
                        <td>{item?.city}</td>
                        <td>{item?.state}</td>
                        <td>{item?.pincode}</td>
                        {/* <td>{item?.clientid}</td>
                        <td>{item?.exponame}</td>
                        <td>{item?.expoyear}</td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
          {!loading && filteredList.length > 0 && (
            <div className="pagination-container">
              <div className="pagination-info">
                <span>Items per page:</span>
                <select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    setPage(1);
                  }}
                >
                  {[5, 10, 20, 50].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>
                <span>
                  Showing {totalItems > 0 ? startIndex + 1 : 0}-
                  {Math.min(startIndex + pageSize, totalItems)} of {totalItems}
                </span>
              </div>
              <div className="page-buttons">
                <button
                  className="page-btn"
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                >
                  Previous
                </button>
                <span className="page-count">
                  {page} / {totalPages || 1}
                </span>
                <button
                  className="page-btn"
                  disabled={page === totalPages || totalPages === 0}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VisitorsList;